/**
 * Die Auswahl der Rolle (Spec 05a, `access-invite-role` / `access-add-role` /
 * `access-role-<user_id>`). Die Optionen kommen aus `GET /access/roles` —
 * kein Client kennt die Rangfolge der Rollen selbst (I9, Spec „`GET
 * /access/roles` liefert … Kein Client kennt die Reihenfolge der Rollen").
 *
 * Dieselbe Aufteilung wie `features/tenants/LegalFormField.tsx`: Die
 * Darstellung liegt in `components/EnumSelectField`, hier bleibt nur die
 * Abfrage und die Beschriftung.
 */

import { useRoles } from '@/features/access/api'
import { EnumSelectField } from '@/components/EnumSelectField'
import type { FieldError } from '@/components/FormField'

interface RoleSelectFieldProps {
  readonly label?: string
  readonly testId: string
  readonly errorPrefix: string
  readonly value: string
  readonly onChange: (value: string) => void
  readonly error: FieldError | undefined
  readonly disabled?: boolean
}

export function RoleSelectField({
  label = 'Rolle',
  testId,
  errorPrefix,
  value,
  onChange,
  error,
  disabled = false,
}: RoleSelectFieldProps) {
  const rolesQuery = useRoles()

  return (
    <EnumSelectField
      label={label}
      testId={testId}
      apiField="role"
      errorPrefix={errorPrefix}
      options={rolesQuery.data ?? []}
      isPending={rolesQuery.isPending}
      value={value}
      onChange={onChange}
      error={error}
      disabled={disabled}
      required
    />
  )
}
